var _circle, _circle2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCarticon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 171 107"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 47.1,
    cy: 95.8,
    r: 11.2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 109.1,
    cy: 95.8,
    r: 11.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M145.5 0h-2.7l-35.2 60.9H51.4L16.2 0H0l43.3 75h72.4l35.2-61h20V0z"
  })));
}
export default SvgCarticon;